import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import userReducer from './user';
import taskReducer from './task';
import pathReducer from './path';
import audioReducer from './audio';
import layoutOptionsReducer from './layoutOptions';

export default function() {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const reducers = combineReducers({
    user: userReducer,
    task: taskReducer,
    path: pathReducer,
    audio: audioReducer,
    layoutOptions: layoutOptionsReducer
  });

  return createStore(reducers, composeEnhancers(applyMiddleware(thunk)));
}



// WEBPACK FOOTER //
// ../core/src/store/create.js